import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const [subcat, setSubCat] = useState([
    { productsubcategoryname: "T-Shirt" },
    { productsubcategoryname: "Hoodies" },
    { productsubcategoryname: "Sweatshirt" },
    { productsubcategoryname: "Jackets" },
  ]);

  const [subcat2, setSubCat2] = useState([
    { productsubcategoryname: "T-Shirt" },
    { productsubcategoryname: "Hoodies" },
    { productsubcategoryname: "Sweatshirt" },
  ]);

  const nav = useNavigate();

  // Mock navigation function for demo
  const navigate = (path) => {
    console.log(`Navigate to: ${path}`);
    nav(path);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className=" text-gray-900 py-16 px-4 border-t border-gray-100 bg-[#f2f2f2]">
      <div className="max-w-[1391px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-16">
          {/* Categories Section */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide text-left">
              Categories
            </h3>
            <ul className="space-y-3">
              <li
                onClick={() => {
                  scrollToTop();
                  navigate(`/category/men/All`);
                }}
                className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer transition-colors duration-200 text-left"
              >
                Men
              </li>
              <li
                onClick={() => {
                  scrollToTop();
                  navigate(`/category/women/All`);
                }}
                className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer transition-colors duration-200 text-left"
              >
                Women
              </li>
              <li
                onClick={() => {
                  scrollToTop();
                  navigate(`/category/Kids/All`);
                }}
                className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer transition-colors duration-200 text-left"
              >
                Kids
              </li>
            </ul>
          </div>

          {/* Men Section */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide text-left">
              Men
            </h3>
            <ul className="space-y-3">
              {subcat &&
                subcat.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      scrollToTop();
                      navigate(`/category/men/${item.productsubcategoryname}`);
                    }}
                    className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer transition-colors duration-200 text-left"
                  >
                    {item.productsubcategoryname}
                  </li>
                ))}
            </ul>
          </div>

          {/* Women Section */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide text-left">
              Women
            </h3>
            <ul className="space-y-3">
              {subcat2 &&
                subcat2.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      scrollToTop();
                      navigate(
                        `/category/women/${item.productsubcategoryname}`
                      );
                    }}
                    className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer transition-colors duration-200 text-left"
                  >
                    {item.productsubcategoryname}
                  </li>
                ))}
            </ul>
          </div>

          {/* Kids Section */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide text-left">
              Kids
            </h3>
            <ul className="space-y-3">
              <li
                onClick={() => {
                  scrollToTop();
                  navigate(`/category/Kids/T-Shirt`);
                }}
                className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer transition-colors duration-200 text-left"
              >
                T-Shirt
              </li>
              <li
                onClick={() => {
                  scrollToTop();
                  navigate(`/category/Kids/Hoodies`);
                }}
                className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer transition-colors duration-200 text-left"
              >
                Hoodies
              </li>
              <li
                onClick={() => {
                  scrollToTop();
                  navigate(`/category/Kids/Sweatshirt`);
                }}
                className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer transition-colors duration-200 text-left"
              >
                Sweatshirt
              </li>
            </ul>
          </div>

          {/* Customer Service Section */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide w-full  text-left">
              Customer Service
            </h3>
            <ul className="space-y-3  text-left">
              <li>
                <a
                  href="https://wa.me/8826615660"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 transition-colors duration-200 w-full  text-left"
                >
                  Contact us
                </a>
              </li>
              <li
                onClick={() => navigate("/faq")}
                className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer transition-colors duration-200 w-full  text-left"
              >
                FAQ's
              </li>
            </ul>
          </div>

          {/* Company Section */}
          <div className="space-y-4 text-left">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide w-full  text-left w-full  text-left">
              Company
            </h3>
            <ul className="space-y-3">
              <li
                onClick={() => navigate("/privacy-policy")}
                className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer transition-colors duration-200 w-full  text-left"
              >
                Privacy Policy
              </li>
              <li
                onClick={() => navigate("/terms")}
                className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer transition-colors duration-200"
              >
                Terms and Conditions
              </li>
            </ul>
          </div>
        </div>

        {/* Newsletter Section */}
        <div className="bg-gray-50 rounded-2xl p-8 mb-12">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="flex-1">
              <h3 className="text-lg w-full text-left font-semibold text-gray-900 mb-2">
                Follow Us
              </h3>
              <p className="text-sm text-gray-600 max-w-md text-left">
                Apply for our free membership to receive exclusive deals, news,
                and events.
              </p>
            </div>
            <div className="flex items-center gap-4 flex-shrink-0">
              <a
                href="https://www.facebook.com/profile.php?id=61567288265655"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:text-blue-600 hover:bg-blue-50 transition-all duration-200 shadow-sm"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/blazestore.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:text-pink-600 hover:bg-pink-50 transition-all duration-200 shadow-sm"
              
             >
                <svg
                  width="w-5"
                  height="h-5"
                  viewBox="0 0 100 100"
                  xmlns="http://www.w3.org/2000/svg"
                  
                >
                  <rect
                    x="20"
                    y="20"
                    width="60"
                    height="60"
                    rx="22"
                    ry="22"
                    fill="#555"
                    stroke="none"
                  />

                  <circle
                    cx="50"
                    cy="50"
                    r="18"
                    fill="none"
                    stroke="white"
                    stroke-width="3"
                  />

                  <circle
                    cx="50"
                    cy="50"
                    r="11"
                    fill="none"
                    stroke="white"
                    stroke-width="3"
                  />

                  <circle cx="68" cy="32" r="4" fill="white" />
                </svg>
              </a>
              <a
                href="https://wa.me/8826615660"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:text-green-600 hover:bg-green-50 transition-all duration-200 shadow-sm"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-8 border-t border-gray-200">
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-4">
              <div className=" rounded-2xl px-4 py-2 flex items-center gap-2">
                <img src="/image/blaze.png" className="w-[121px] h-[31px]" />
              </div>
            </div>
          </div>

          <div className="text-center md:text-right">
            <p className="text-xs text-gray-500 mb-1 w-full text-left">
              © 2025, Blazestore.
            </p>
            <p className="text-xs text-gray-400 w-full text-left">
              a part of clan business private limited
            </p>
            <div className="text-xs text-gray-400 mt-2 max-w-md w-full text-left">
              Head Office: A-49, Engine House, Mohan Industrial Estate, Mathura
              Road, New Delhi, India, PIN - 110044
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
